import React from "react";

/** Label + control, with the CDT code shown as secondary text when there is one. */
export function Field({ label, code, hint, children, span }) {
  return (
    <div className="bw-field" style={span ? { gridColumn: "1 / -1" } : undefined}>
      <label>
        {label}
        {code ? <span className="bw-code">({code})</span> : null}
      </label>
      {children}
      {hint ? <p className="bw-hint">{hint}</p> : null}
    </div>
  );
}

/** The form's ubiquitous Y / N circle. */
export function YesNo({ value, onChange }) {
  const opts = ["Y", "N"];
  return (
    <div className="bw-inline">
      {opts.map(function (o) {
        const active = value === o;
        return (
          <button
            key={o}
            type="button"
            onClick={function () { onChange(active ? "" : o); }}
            style={{
              width: 40, height: 30, borderRadius: 8, cursor: "pointer",
              border: active ? "1px solid #6b43b5" : "1px solid #e0d8f0",
              background: active ? "#6b43b5" : "#fff",
              color: active ? "#fff" : "#6f6588", fontWeight: 600, fontSize: 13,
            }}
          >
            {o}
          </button>
        );
      })}
    </div>
  );
}
